<pc-responsive-abstract-card [color]="'primary'" [size]="size">
  <section class="detail-card" [ngClass]="{ return: dateType === ButtonDateType.Return }">
    @if (showButtonImageAirplane) {
      <div class="img-wrapper">
        <img
          [alt]="dateType === ButtonDateType.Departure ? departureAltText : returnAltText"
          [src]="PcButtonIcon.WHEN_DEPARTURE_SM"
        />
      </div>
    }
    <div class="detail-content {{ size }}">
      <span class="sub-title subtitle">{{ details?.weekDay }}</span>
      <span class="title header-title" [ngClass]="{ isLtr: isLTR }">{{ details?.monthDay }}</span>
      <span class="title header-title">{{ details?.year }}</span>
    </div>
    <button
      pcButton
      tabindex="0"
      [attr.aria-label]="editButtonDescription"
      [color]="'link-transparent'"
      [size]="'xsmall'"
      (click)="editDetails()"
      (keydown.enter)="editDetails()"
      (keydown.space)="editDetails()"
    >
      <div class="btn-edit" [ngClass]="businessUnit === BusinessUnit.IL ? 'body-small' : 'pc-tca-edit-btn'">
        {{ editButtonText }}
      </div>
    </button>
  </section>
</pc-responsive-abstract-card>
